"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusSessionIdStorage = void 0;
const react_1 = require("react");
const use_persisted_state_1 = __importDefault(require("use-persisted-state"));
const useSessionIdState = use_persisted_state_1.default('cirrus-session-ids', window.sessionStorage);
function useCirrusSessionIdStorage(host) {
    var _a;
    const [storedSessionIds, setStoredSessionIds] = useSessionIdState({});
    const setStoredSessionIdsRef = react_1.useRef(setStoredSessionIds);
    react_1.useEffect(() => {
        setStoredSessionIdsRef.current = setStoredSessionIds;
    }, [setStoredSessionIds]);
    const sessionId = (_a = storedSessionIds === null || storedSessionIds === void 0 ? void 0 : storedSessionIds[host]) !== null && _a !== void 0 ? _a : null;
    const setSessionId = react_1.useCallback((sessionId) => {
        setStoredSessionIdsRef.current(old => (Object.assign(Object.assign({}, (old !== null && old !== void 0 ? old : {})), { [host]: sessionId })));
    }, [host]);
    const clearSessionId = react_1.useCallback(() => {
        const _a = storedSessionIds !== null && storedSessionIds !== void 0 ? storedSessionIds : {}, _b = host, throwAway = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        setStoredSessionIdsRef.current(rest);
    }, [host, storedSessionIds]);
    return react_1.useMemo(() => [sessionId, setSessionId, clearSessionId], [sessionId, setSessionId, clearSessionId]);
}
exports.useCirrusSessionIdStorage = useCirrusSessionIdStorage;
//# sourceMappingURL=useCirrusSessionIdStorage.js.map